import { WithClass } from '@decadia/shared/types/extend-default-props'
import clsx from 'clsx'
import { motion } from 'framer-motion'
import { t } from 'i18next'
import { FC, useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useEtracker } from '../../hooks/use-etracker'
import { useStore } from '../../hooks/use-store'
import { NoResultsIllustration } from '../../icons/no-results-illustration'
import { Button } from '../button/button'
import { TextReveal } from '../text-reveal/text-reveal'
import styles from './no-results-page.module.css'

export const NoResultsPage: FC<WithClass> = ({ className }) => {
	const { resetState, links, feedType } = useStore(
		useShallow(({ resetState, links, feedType }) => ({
			resetState,
			links,
			feedType,
		}))
	)
	const { trackPageView, trackEvent } = useEtracker()
	const careerLink = feedType === 'internal' ? 'https://jobs.rwe.com/?isInternalUser=true' : links?.career

	useEffect(() => {
		trackEvent(['Matching-Results', 'Results-0'])
		trackPageView('NoResults')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<motion.div className={clsx(styles.container, className)}>
			<TextReveal
				className={styles.headline}
				sentences={[{ text: t('noResultsPage.headline') }]}
				duration={1}
				autoSize={false}
			/>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{
					opacity: 1,
				}}
				transition={{ delay: 1 }}
				className={styles.content}
			>
				<h3 className={clsx(styles.subline, 'medium')}>{t('noResultsPage.subline')}</h3>

				<p className={styles.body}>{t('noResultsPage.body')}</p>

				<Button
					className={styles.button}
					type="secondary"
					dark
					href={careerLink}
					onClick={() => {
						trackEvent(t('cards.button.linkToJob'))
					}}
					target="_blank"
					rel="noreferrer"
				>
					{t('noResultsPage.jobsButtonLabel')}
				</Button>
				<Button type="tertiary" dark className={styles.button} onClick={resetState}>
					{t('noResultsPage.resetButtonLabel')}
				</Button>
			</motion.div>
			<NoResultsIllustration
				initial={{ opacity: 0 }}
				animate={{
					opacity: 1,
				}}
				transition={{ delay: 1 }}
				className={styles.image}
			/>
		</motion.div>
	)
}
